var _g, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 27.25C21.3178 27.25 27.25 21.3178 27.25 14C27.25 6.68223 21.3178 0.75 14 0.75C6.68223 0.75 0.75 6.68223 0.75 14C0.75 21.3178 6.68223 27.25 14 27.25Z",
    stroke: "black",
    strokeWidth: 1.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1041 9.017C20.1041 9.41588 19.9858 9.80581 19.7642 10.1375C19.5426 10.4692 19.2277 10.7277 18.8592 10.8804C18.4907 11.0331 18.0852 11.0731 17.6939 10.9953C17.3027 10.9176 16.9433 10.7256 16.6612 10.4436C16.3791 10.1616 16.1869 9.8023 16.1089 9.41111C16.031 9.01992 16.0708 8.6144 16.2233 8.24582C16.3758 7.87724 16.6342 7.56216 16.9658 7.34041C17.2973 7.11866 17.6872 7.0002 18.0861 7C18.351 6.99987 18.6134 7.05194 18.8582 7.15325C19.1031 7.25455 19.3255 7.4031 19.5129 7.59041C19.7004 7.77772 19.849 8.00012 19.9504 8.2449C20.0519 8.48968 20.1041 8.75204 20.1041 9.017Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.034 13.724C12.034 14.1229 11.9157 14.5128 11.6941 14.8445C11.4726 15.1762 11.1576 15.4347 10.7891 15.5874C10.4206 15.7401 10.0151 15.7801 9.62387 15.7023C9.23264 15.6246 8.87324 15.4326 8.59112 15.1506C8.309 14.8686 8.11682 14.5093 8.03888 14.1181C7.96094 13.7269 8.00074 13.3214 8.15325 12.9529C8.30576 12.5843 8.56413 12.2692 8.89569 12.0474C9.22725 11.8257 9.61712 11.7072 10.016 11.707C10.281 11.7069 10.5434 11.759 10.7882 11.8603C11.033 11.9616 11.2555 12.1101 11.4429 12.2974C11.6303 12.4848 11.7789 12.7071 11.8804 12.9519C11.9818 13.1967 12.034 13.4591 12.034 13.724Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1041 18.432C20.1041 18.8309 19.9858 19.2208 19.7642 19.5525C19.5426 19.8842 19.2277 20.1427 18.8592 20.2954C18.4907 20.4481 18.0852 20.4881 17.6939 20.4104C17.3027 20.3326 16.9433 20.1406 16.6612 19.8586C16.3791 19.5766 16.1869 19.2173 16.1089 18.8261C16.031 18.435 16.0708 18.0294 16.2233 17.6609C16.3758 17.2923 16.6342 16.9772 16.9658 16.7555C17.2973 16.5337 17.6872 16.4152 18.0861 16.415C18.351 16.4149 18.6134 16.467 18.8582 16.5683C19.1031 16.6696 19.3255 16.8181 19.5129 17.0055C19.7004 17.1928 19.849 17.4152 19.9504 17.6599C20.0519 17.9047 20.1041 18.1671 20.1041 18.432Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7581 14.74L16.3511 17.416",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3441 10.033L11.7581 12.709",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.1c6089a609827107c70d607c77a05eb8.svg";
export { ForwardRef as ReactComponent };